"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundsService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const refund_entity_1 = require("./refund.entity");
let RefundsService = class RefundsService {
    constructor(refundRepo) {
        this.refundRepo = refundRepo;
    }
    findAll(customerId, status) {
        const where = {};
        if (customerId)
            where.customer = { id: customerId };
        if (status)
            where.status = status;
        return this.refundRepo.find({
            where,
            relations: ['customer', 'relatedOrder', 'createdBy', 'teamLeadReviewedBy', 'managementReviewedBy'],
            order: { createdAt: 'DESC' },
        });
    }
    async findById(id) {
        const refund = await this.refundRepo.findOne({
            where: { id },
            relations: ['customer', 'relatedOrder', 'createdBy', 'teamLeadReviewedBy', 'managementReviewedBy'],
        });
        if (!refund)
            throw new common_1.NotFoundException(`Refund #${id} not found`);
        return refund;
    }
    async create(dto) {
        const year = new Date().getFullYear();
        const count = await this.refundRepo.count();
        const seq = String(count + 1).padStart(5, '0');
        const refundNumber = `REF-${year}-${seq}`;
        const refund = this.refundRepo.create({
            refundNumber,
            customer: { id: dto.customerId },
            relatedOrder: dto.orderId ? { id: dto.orderId } : undefined,
            requestType: dto.requestType,
            reason: dto.reason,
            patientMedicalConcern: dto.patientMedicalConcern,
            requestedAmount: dto.requestedAmount,
            createdBy: { id: dto.createdById },
            status: refund_entity_1.RefundStatus.TEAM_LEAD_REVIEW,
        });
        return this.refundRepo.save(refund);
    }
    async teamLeadReview(id, satisfied, remarks, teamLeadId) {
        const refund = await this.findById(id);
        refund.teamLeadRemarks = remarks;
        refund.teamLeadReviewedBy = { id: teamLeadId };
        refund.teamLeadReviewedAt = new Date();
        if (satisfied) {
            refund.status = refund_entity_1.RefundStatus.APPROVED;
        }
        else {
            refund.status = refund_entity_1.RefundStatus.MANAGEMENT_REVIEW;
        }
        return this.refundRepo.save(refund);
    }
    async managementReview(id, satisfied, remarks, managementId, approvedAmount, refundMethod) {
        const refund = await this.findById(id);
        refund.managementRemarks = remarks;
        refund.managementReviewedBy = { id: managementId };
        refund.managementReviewedAt = new Date();
        if (satisfied) {
            refund.status = refund_entity_1.RefundStatus.APPROVED;
            if (approvedAmount !== undefined)
                refund.approvedAmount = approvedAmount;
            if (refundMethod)
                refund.refundMethod = refundMethod;
        }
        else {
            // not satisfied → issue refund directly
            refund.status = refund_entity_1.RefundStatus.REFUNDED;
            refund.refundedAt = new Date();
            if (approvedAmount !== undefined)
                refund.approvedAmount = approvedAmount;
            if (refundMethod)
                refund.refundMethod = refundMethod;
        }
        return this.refundRepo.save(refund);
    }
    async markRefunded(id, approvedAmount, refundMethod, managementId) {
        const refund = await this.findById(id);
        refund.status = refund_entity_1.RefundStatus.REFUNDED;
        refund.approvedAmount = approvedAmount;
        refund.refundMethod = refundMethod;
        refund.managementReviewedBy = { id: managementId };
        refund.refundedAt = new Date();
        return this.refundRepo.save(refund);
    }
};
exports.RefundsService = RefundsService;
exports.RefundsService = RefundsService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(refund_entity_1.Refund)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object])
], RefundsService);
